module.exports = __webpack_public_path__ + "img/box-arrow-up-left.43168716.svg";